import React from 'react';
import { useRecoilValue } from 'recoil';
import { CardBody } from '../../components/CardBody';
import { CardHeader } from '../../components/CardHeader';

import { allProductsState } from '../../recoil/atoms';
import { ShopNowCardFooter, ShopNowCardSection } from '../HomeLander/HomeLanderMobile';
import { HeroCallout } from '../HeroCallout';
import { WistiaPanel } from '../../components/WistiaPanel';
import { NewsIcons } from '../../product_detail/components/NewsIcons';
import { ShopAllColors } from '../components/ShopAllColors';
import { ProductFeatures } from '../components/ProductFeatures';
import { LanderTopHero } from '../components/LanderTopHero';
import { ProductHandle } from '../../enums/ProductHandle.enum';
import { CardFooter } from '../../components/CardFooter';
import { useLanderControls } from '../LanderContext';
import { ProductReviewQuote } from '../components/ProductReviewQuote';

export const SuperPowerBriefLanderMobile: React.FC = () => {
  const allProducts = useRecoilValue(allProductsState);
  const { scrollToProductSection } = useLanderControls();

  const wistiaVideoId = 'txjj1yry1r';
  const padding = { padding: '145.0% 0 0 0' };

  return (
    <>
      <CardBody>
        <LanderTopHero heroImage={'mobile-superpowerbrief-lander-top-hero-1.jpg'} title={'SuperPower Brief'} subTitle={'The next generation of shapewear.'}>
          <HeroCallout
            orderIndex={0}
            label="Never rolls down"
            labelColor="black"
            inlineStyles={{
              mobile: {
                left: `62%`,
                top: `43%`,
                flexDirection: 'row-reverse',
              },
            }}
          />
          <HeroCallout
            orderIndex={1}
            label={
              <>
                Posture
                <br /> support
              </>
            }
            labelColor="black"
            inlineStyles={{
              mobile: {
                left: `5%`,
                top: `44%`,
                flexDirection: 'row',
              },
            }}
          />
          <HeroCallout
            orderIndex={2}
            label={
              <>
                Targeted
                <br /> compression
              </>
            }
            titleStyles={{ lineHeight: '22px', marginTop: 10, textAlign: 'center' }}
            inlineStyles={{
              mobile: {
                left: `43%`,
                top: `61%`,
                flexDirection: 'column-reverse',
              },
            }}
          />
          <HeroCallout
            orderIndex={3}
            label={
              <>
                No panty <br />
                lines
              </>
            }
            labelColor="black"
            titleStyles={{ lineHeight: '26px', textAlign: 'left' }}
            inlineStyles={{
              mobile: {
                left: `2%`,
                top: `76%`,
                flexDirection: 'row',
              },
            }}
          />
        </LanderTopHero>
      </CardBody>
      <ShopNowCardFooter onClick={scrollToProductSection} />
      <CardHeader />
      <CardBody>
        <NewsIcons />
        <ProductFeatures
          features={[
            {
              imgName: 'feature-spb-desktop-1.png',
              title: 'Doesn’t roll down',
              description: 'Flexible boning keeps the garment from rolling down.',
            },
            {
              imgName: 'feature-spb-desktop-3.png',
              title: 'Targeted compression',
              description: 'Varied levels of compression shape without squeezing.',
            },
            {
              imgName: 'feature-spb-desktop-2.png',
              title: 'Booty smoothing',
              description: 'Compressive mesh smooths your booty without panty lines.',
            },
          ]}
        />
        <ProductReviewQuote
          quoteText={
            <>
              We saw an opportunity to make shapewear more effective, beautiful and reliable. Every feature is rigorously tested from size XS-3X, so when you
              put it on you will immediately feel a difference.
            </>
          }
          author="BETSIE, HONEYLOVE FOUNDER"
          imgName="superpower-brief-quote-mobile.jpg"
        />
        <ShopNowCardSection onClick={scrollToProductSection} />
        <WistiaPanel videoId={wistiaVideoId} responsivePadding={padding} />
        <ShopAllColors product={allProducts[ProductHandle.SuperPowerBrief]} />
      </CardBody>
      <CardFooter />
    </>
  );
};

export default SuperPowerBriefLanderMobile;
